import {
  ChangeDetectionStrategy,
  Component,
  inject
} from '@angular/core';
import { CommonModule } from '@angular/common';

import { CompositionCustomizationService } from '../services/composition-customization.service';
import { CustomizationGroupSelectorComponent } from './customization-group-selector.component';
import {CustomizationRowComponent} from '@app/model-composer/components/customization-row.component';

@Component({
  selector: 'app-composition-customization',
  standalone: true,
  imports: [
    CommonModule,
    CustomizationGroupSelectorComponent,
    CustomizationRowComponent
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <section class="ipe:h-full ipe:flex ipe:flex-col ipe:flex-1 ipe:min-h-0 ipe:overflow-y-auto ipe:pb-4">
      <app-customization-group-selector />
      @if (activeGroup(); as group) {
        <div class="ipe:space-y-4 ipe:flex ipe:flex-col">
          @for (row of group.customizationRows; track row.vid) {
            @if (row?.show) {
              <app-customization-row [row]="row" />
            }
          }
        </div>
      }
    </section>
  `,
  styles: [
    `
      @import 'tailwindcss' prefix(ipe);
      @theme {
        --font-display: 'ABC Walter Neue', sans-serif;
        --font-roboto: 'ABC Walter Neue', sans-serif;
        --font-sans: 'ABC Walter Neue', sans-serif;
      }
    `
  ]
})
export class CompositionCustomizationComponent {
  private service = inject(CompositionCustomizationService);
  readonly activeGroup = this.service.activeGroup;
}
